import { Content } from '@radix-ui/react-tabs'

import { styled } from '~/styled'

const StyledTabsContent = styled(Content, {
  base: ['grow', 'font-body']
})

export const TabsContent = StyledTabsContent

TabsContent.displayName = 'TabsContent'
